import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { NotificationService } from 'src/app/services/notification-service';

@Component({
  selector: 'app-courier-waybil',
  templateUrl: './courier-waybil.component.html',
  styleUrls: ['./courier-waybil.component.scss']
})
export class CourierWaybilComponent implements OnInit {
  form: FormGroup;
  value:any;
  constructor(
    private formBuilder: FormBuilder,
    private ApplicationDataService: ApplicationDataService,
    private toast:NotificationService,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      search: ['', Validators.required],
    })
  }

  searchinput() {
    let data = this.form.value.search;
    let title;
    if(this.form.valid)
    this.ApplicationDataService.getCourierWaybill(data).subscribe((result) => {
      if (result == "No waybill number found") {
       title='nobill' 
       this.toast.showError(result)
      }
      else if (result == "No records found") {
        this.toast.showError(result)
      }
      else if (result) {
        let data=result;
        window.open(data.url, 'CourierWaybill');
        
      }
      // const dialogref = this.matdialog.open(CourierWaybillPopupComponent, {
      //   autoFocus: false,
      //   disableClose: true,
      //   panelClass: 'mat-dialog',
      //   width: "30%",
      //   data:{
      //     title:title
      //   }
      // });
    })
  }
  clearFilter() {
    this.form.controls['search'].setValue("");

  }

}
